import type { FC } from 'react';

import type { FormFieldProps } from '@zen/Components/Form/FormField';
import FormField from '@zen/Components/Form/FormField';
import type { FormInstance } from '@zen/Components/Form/types';
import ScoreSelect from '@zen/Components/ScoreSelect';
import type { Score, ScoreHintLabels } from '@zen/Components/ScoreSelect/helpers';
import type { Nullable } from '@zen/utils/typescript';

interface Props extends FormFieldProps {
  hasError?: boolean;
  hintLabels?: ScoreHintLabels;
  isDisabled?: boolean;
}

const FormScoreSelect: FC<Props> = (props) => {
  return (
    <FormField hideLabel={true} {...props}>
      {(field: { error: boolean; name: string; value: Nullable<Score> }, form: FormInstance<object>) => {
        const { isDisabled, hintLabels } = props;

        return (
          <ScoreSelect
            hasError={field.error}
            hintLabels={hintLabels}
            isDisabled={isDisabled}
            onChange={(score: Score): void => {
              form.setFieldValue(field.name, score);
            }}
            value={field.value}
          />
        );
      }}
    </FormField>
  );
};

export default FormScoreSelect;
